/// <reference path="../Bases/ItemDialog.ts" />
namespace _Ext {

    @Serenity.Decorators.registerClass()
    export class StockInItemEditorDialog<TEntity> extends ItemDialog<TEntity, any> {

        public ItemMaster: any;
        public masterId: number;
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public MarkUpPolicyId: number;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public Closing: boolean;
        public LotNo: any;
        public Coef: number;

        protected get_ExtDialogOptions(): ExtDialogOptions { return q.DefaultEditorDialogOptions; }



        protected getIdProperty() { return "__id"; }

        constructor(opt?) {
            super(opt);
            // #region Field Change Events

            this.form.Pieces.changeSelect2(e => {
                this.UpdateLabor();
                if (this.form.HasBom.value)
                    this.CalculateTotals();
                else
                    this.CalculateRate();
            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
                this.form.ProductSizeId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.ProductSizeId.updateItems();
                TabAurous.ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);

                //this.Setfields();
            })

            this.form.Weight.changeSelect2(e => {
                if (!isNaN(this.form.Weight.value)) {
                    this.UpdateLabor();
                    this.CalculateRate();
                }

            });

            this.form.UnitRate.changeSelect2(e => {
                if (this.form.UnitRate.value != null)
                    this.CalculateRate();
            });

            this.form.CalcOnId.changeSelect2(e => {
                if (this.form.CalcOnId.value != "")
                    this.CalculateRate();
            });

            this.form.NetAmount.changeSelect2(e => {
                if (this.form.NetAmount.value != null)
                    this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
            });

            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {

                    let ProductTypeDetails: TabAurous.OMS.ProductTypeRow;

                    TabAurous.OMS.ProductTypeService.Retrieve({ EntityId: Q.parseInteger(this.form.ProductTypeId.value) },
                        response => ProductTypeDetails = response.Entity,
                        { async: false }

                    );

                    this.form.ItemTypeId.value = ProductTypeDetails.ItemTypeId
                    //this.entity.ItemTypeId = this.form.ItemTypeId.value;
                    //this.entity.SalesCostMethodId = ProductTypeDetails.SalesCostMethodId;
                    //this.entity.PurchaseCostMethodId = ProductTypeDetails.PurchaseCostMethodId;
                    this.form.HSN.value = ProductTypeDetails.HSN;
                    this.form.TaxCode.value = ProductTypeDetails.TaxCode;
                    this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                    TabAurous.ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
                    //this.Setfields();
                }
            });

            this.form.UnitLabour.changeSelect2(e => {
                if (this.form.UnitLabour.value != null) {
                    this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;
                    if (this.form.Pieces.value != null) {
                        this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
                    }
                }
            });

            this.form.ProductCode.changeSelect2(e => {
                if (this.form.ProductCode.value != null) {
                    try {

                        let PrdId = 0;
                        var equalFilter = { "ProductCode": this.form.ProductCode.value.toUpperCase() };

                        TabAurous.OMS.ProductMasterService.List({ EqualityFilter: equalFilter, Take: 1 },
                            response => {
                                if (response.Entities.length > 0)
                                    PrdId = response.Entities[0].ProductId;
                            }, {
                            async: false
                        }
                        );

                        if (PrdId > 0) {
                            Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                            this.form.ProductCode.value = "";
                            this.form.ProductCode.element.focus();
                            return;
                        }
                        else {
                            this.form.ProductCode.value = this.form.ProductCode.value.toUpperCase();
                        }

                    }
                    catch (undefined) {

                    }
                }
            });

            this.form.SubCategoryId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.SubCategoryId.value))
                    TabAurous.ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);

                //this.Setfields();
            });

            this.form.HasBom.changeSelect2(e => {
                var self = this;
                if (this.form.BOMDetails.getItems().length > 0) {
                    q.information(q.text("Message.Voucher.ReadOnly", "Are you sure?"), q.text("Message.Voucher.ReadOnlyInfo", "This will remove all components"), true, function () {
                        self.removeBOM();
                        TabAurous.ItemFieldHelper.PurchaseItemFields(self, self.ItemMaster.form.VoucherTypeId.value);
                    }, function () {
                        self.form.HasBom.value = true;
                    });
                } else
                    TabAurous.ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
            });

            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.KaratId.value)) {

                    var KaratId = Q.toId(this.form.KaratId.value);
                    var purity: TabAurous.OMS.AttributeMasterRow;
                    TabAurous.OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                        purity = response.Entity
                    }, { async: false });
                    var min = purity.MinPurity;
                    var max = purity.MaxPurity;
                    var std = purity.StdPurity;
                    q.showAndSetRequiredField(this.form.Purity);
                    this.form.Purity.value = std;
                    this.form.Purity.value = std;
                    var date = new Date((this.parentEditor.parentDialog as any).form.TransDate.value);
                    this.form.UnitRate.value = TabAurous.RateHelper.GetMetalRate(parseInt(this.form.MetalId.value), parseInt(this.form.KaratId.value), false, date) / this.ExchangeRate;
                }

            });

            this.form.MetalId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.MetalId.value)) {
                    q.showAndSetRequiredField(this.form.KaratId);
                    this.form.KaratId.cascadeField = "Num1";
                    this.form.KaratId.cascadeValue = this.form.MetalId.value;
                }
            })

            this.form.Purity.change(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: TabAurous.OMS.AttributeMasterRow;
                TabAurous.OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                var min = purity.MinPurity;
                var max = purity.MaxPurity;
                var std = purity.StdPurity;
                if (this.form.Purity.value != null) {
                    var current = this.form.Purity.value;
                    if (current < min || current > max) {
                        Q.alert("Enter Purity between  " + min + "  to  " + max);
                        this.form.Purity.value = this.form.Purity.value;
                    }
                    this.CalculateRate();
                }
            });

            this.form.StoneSizeId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.ShapeId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.SieveId.changeSelect2(e => {
                var SieveId = Q.toId(this.form.SieveId.value);
                var sievegroupid = TabAurous.OMS.AttributeMasterRow.getLookup().itemById[SieveId].GroupSieveId;
                this.form.GroupSieveId.value = sievegroupid.toString();
                this.GetRate();
            });

            this.form.QualityId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.StoneColorId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.MF.changeSelect2(e => {
                this.form.MFAmount.value = this.form.GrossAmount.value / this.form.MF.value;
            });

            this.form.StoneRate.changeSelect2(e => {
                this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
                this.CalculateRate();
            });

            this.form.StoneWeight.changeSelect2(e => {
                this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
                this.CalculateRate();
            });

            // #endregion




        }

        removeBOM() {
            var item = [];
            this.form.BOMDetails.view.setItems(item, true);
        }

        public onSave: (options: Serenity.ServiceOptions<Serenity.SaveResponse>,
            callback: (response: Serenity.SaveResponse) => void) => void;

        public onDelete: (options: Serenity.ServiceOptions<Serenity.DeleteResponse>,
            callback: (response: Serenity.DeleteResponse) => void) => void;

        public destroy() {
            this.onSave = null;
            this.onDelete = null;
            super.destroy();
        }

        protected updateInterface() {
            super.updateInterface();
            this.saveAndCloseButton.find('.button-inner').text(this.isNew() ? (Q.tryGetText('Controls.AddButton') || 'Add') : (Q.tryGetText('Controls.ApplyButton') || 'Apply'));
            this.toolbar.findButton('btn-save-and-new').find('.button-inner').text(this.isNew() ? (Q.tryGetText('Controls.SaveAndNew') || 'Add & New') : (Q.tryGetText('Controls.ApplyAndNew') || 'Apply & New'));

            // apply changes button doesn't work properly with in-memory grids yet
            if (this.applyChangesButton) {
                this.applyChangesButton.hide();
            }

            if (this.parentEditor && this.parentEditor.isReadOnly == true) {
                this.setReadOnly(true);
                this.saveAndCloseButton.addClass('disabled');
                this.deleteButton.addClass('disabled');
                this.applyChangesButton.addClass('disabled');
                this.toolbar.findButton('btn-save-and-new').addClass('disabled');
                // remove required asterisk (*)
                this.element.find('sup').hide();

            }
        }

        protected saveHandler(options: Serenity.ServiceOptions<Serenity.SaveResponse>,
            callback: (response: Serenity.SaveResponse) => void): void {
            this.onSave && this.onSave(options, callback);
        }

        protected deleteHandler(options: Serenity.ServiceOptions<Serenity.DeleteResponse>,
            callback: (response: Serenity.DeleteResponse) => void): void {
            this.onDelete && this.onDelete(options, callback);
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            return btns;
        }

        // **** Validate Product in stock before Delete ****
        private confirmBeforeDelete(oldEvt, e) {
            let refid: any;
            TabAurous.Stock.StockItemService.CheckItemTransaction(
                {
                    RefTransId: this.form.TransId.value,
                    RefTransItemId: this.form.TransItemId.value,
                    Line_No: parseInt(this.form.Line_No.value),
                    ProductId: parseInt(this.form.ProductId.value)
                }
                , response => {
                    refid = response.Entities
                }, { async: false })
            if (refid != null && refid.length > 0) {
                if (refid[0].TransId != null || refid[0].TransId > 0) {
                    Q.alert("This Item has been used in transactions Can Not Delete!");
                    return;
                }
            }
            else
                this.doDelete(() => this.dialogClose());
        }

        public CalculateTotals() {

            let IgnorePCSinTotals = q.ToBool(TabAurous.GetConfigValue(1032));
            let SplitLabor = q.ToBool(TabAurous.GetConfigValue(1033));
            if (this.form.HasBom.value) {


                var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
                var labrate = 0.00; var wstper = 0; var wstwt = 0; let Fancy = 0; let others = 0;
                for (var k of this.form.BOMDetails.getItems()) {

                    if (k.ItemTypeId == 104) {
                        Wt += k.Weight;
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                        cts += k.Weight;
                        diapcs += k.Pieces
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                        gms += k.Weight;
                        clrpcs += k.Pieces;
                    }
                    rate += k.BomAmount;
                }

                var LAmount = 0;
                var Wst = 0;
                if (this.form.LaborDetails != null) {
                    if (this.form.LaborDetails.getItems().length > 0)
                        for (var l of this.form.LaborDetails.getItems()) {
                            let discount = l.Discount == undefined ? 0 : l.Discount;
                            if (SplitLabor) {
                                switch (l.CalculateTo) {
                                    case 1:
                                        LAmount += l.LabourAmount - discount;
                                        break;
                                    case 2:
                                        Fancy += l.LabourAmount - discount;
                                        break;
                                    case 3:
                                        others += l.LabourAmount - discount;
                                        break;
                                }
                            }
                            else {
                                if (l.ProcessName == "Wastage")
                                    Wst += l.WstPer;

                                LAmount += l.LabourAmount;
                            }
                        }
                    if (SplitLabor) {
                        this.form.FancyCharges.value = Fancy;
                        this.form.OtherCharges.value = others;
                    }
                }
                //this.form.FacyCharges
                this.form.UnitLabour.value = LAmount;
                this.form.WstPer.value = Wst;
                this.form.WstWt.value = this.form.Weight.value * Wst;

                this.form.NetWeight.value = Wt * this.form.Pieces.value;
                this.form.OtherPieces.value = othrpcs * this.form.Pieces.value || 0;
                this.form.StonePieces.value = clrpcs * this.form.Pieces.value || 0;
                this.form.StoneWeight.value = gms * this.form.Pieces.value;
                this.form.DiamondPieces.value = diapcs * this.form.Pieces.value || 0;
                this.form.DiamondWeight.value = cts * this.form.Pieces.value || 0;
                this.form.OtherWeight.value = 0;

                if (cts > 0)
                    this.form.Weight.value = (Wt + gms + (cts / 5)) * this.form.Pieces.value;
                else
                    this.form.Weight.value = (Wt + gms) * this.form.Pieces.value;

                this.form.UnitRate.value = rate;


                this.form.UnitCost.value = this.form.UnitRate.value + this.form.UnitLabour.value;
                this.form.NetAmount.value = this.form.UnitRate.value;

                if (this.form.Pieces.value != null) {
                    if (SplitLabor)
                        this.form.GrossAmount.value = (this.form.Pieces.value * this.form.NetAmount.value) + this.form.UnitLabour.value + this.form.FancyCharges.value + this.form.OtherCharges.value;
                    else
                        this.form.GrossAmount.value = (this.form.Pieces.value * this.form.NetAmount.value) + this.form.UnitLabour.value;
                }
            }
            else if (!this.form.HasBom.value && this.form.ItemTypeId.value == 101) {
                let Fancy = 0; let others = 0;
                if (this.form.Weight.value == null)
                    this.form.Weight.value = this.form.Weight.value == 0 ? 1 : this.form.Weight.value;

                var LAmount = 0;
                var Wst = 0;
                if (this.form.LaborDetails.getItems().length > 0)
                    for (var l of this.form.LaborDetails.getItems()) {
                        if (SplitLabor) {
                            let discount = l.Discount == undefined ? 0 : l.Discount;
                            switch (l.CalculateTo) {
                                case 1:

                                    LAmount += l.LabourAmount - discount
                                    break;
                                case 2:
                                    Fancy += l.LabourAmount - discount;
                                    break;
                                case 3:
                                    others += l.LabourAmount - discount;
                                    break;
                            }
                        }
                        else {
                            if (l.ProcessName == "Wastage")
                                Wst += l.WstPer;

                            LAmount += l.LabourAmount;
                        }
                    }

                if (SplitLabor) {
                    this.form.FancyCharges.value = Fancy;
                    this.form.OtherCharges.value = others;
                }
                this.form.UnitLabour.value = LAmount;

                //this.form.NetWeight.value = this.form.NetWeight.value == null ? this.entity.NetWeight : this.form.NetWeight.value;
                //this.form.UnitRate.value = this.form.UnitRate.value == null ? this.entity.UnitRate : this.form.UnitRate.value;


                this.form.NetWeight.value = this.form.StoneWeight.value != null ? this.form.Weight.value - this.form.StoneWeight.value : this.form.Weight.value;
                this.form.PureWeight.value = this.form.NetWeight.value * this.form.Purity.value;

                let UseKaratRate = q.ToBool(TabAurous.GetConfigValue(1021));
                if (UseKaratRate == true)
                    this.form.MetalAmount.value = this.form.NetWeight.value * this.form.UnitRate.value;
                else
                    this.form.MetalAmount.value = this.form.NetWeight.value * this.form.UnitRate.value * this.form.Purity.value;

                this.form.NetAmount.value = this.form.MetalAmount.value + this.form.StoneAmount.value + this.form.OtherAmount.value;

                if (parseInt(this.form.CalcOnId.value) == 3) {
                    if (SplitLabor)
                        this.form.GrossAmount.value = (this.form.Pieces.value * this.form.NetAmount.value) + this.form.UnitLabour.value + this.form.FancyCharges.value + this.form.OtherCharges.value;
                    else
                        this.form.GrossAmount.value = (this.form.Pieces.value * this.form.NetAmount.value) + this.form.UnitLabour.value;
                }
                else {
                    if (SplitLabor)
                        this.form.GrossAmount.value = this.form.NetAmount.value + this.form.UnitLabour.value + this.form.FancyCharges.value + this.form.OtherCharges.value;
                    else
                        this.form.GrossAmount.value = this.form.NetAmount.value + this.form.UnitLabour.value - this.form.Discount.value;
                }

            }

            //if (this.form.MF.value > 0)
            //    this.form.MFAmount.value = this.form.GrossAmount.value / this.form.MF.value;

            this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
            this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
 
        }

        protected CalculateRate() {
            let IgnorePCSinTotals = q.ToBool(TabAurous.GetConfigValue(1032));
            let SplitLabor = q.ToBool(TabAurous.GetConfigValue(1033)); 
            if (this.form.ItemTypeId.value != 101 || this.form.ItemTypeId.value == 101 && !this.form.HasBom.value) {
                if (parseInt(this.form.CalcOnId.value) == 4 && this.form.UnitRate.value > 0 || parseInt(this.form.CalcOnId.value) == 5 && this.form.UnitRate.value > 0) {
                    if (this.form.ItemTypeId.value == 101 && !this.form.HasBom.value) {

                        /*this.form.StoneWeight.value = this.form.StoneWeight.value * this.form.Pieces.value;*/
                        this.form.NetWeight.value = this.form.StoneWeight.value != null ? this.form.Weight.value - this.form.StoneWeight.value : this.form.Weight.value;
                        this.form.PureWeight.value = this.form.NetWeight.value * this.form.Purity.value;

                        let UseKaratRate = q.ToBool(TabAurous.GetConfigValue(1021));
                        if (UseKaratRate == true)
                            this.form.MetalAmount.value = this.form.NetWeight.value * this.form.UnitRate.value;
                        else
                            this.form.MetalAmount.value = this.form.NetWeight.value * this.form.UnitRate.value * this.form.Purity.value;

                        this.form.NetAmount.value = this.form.MetalAmount.value + this.form.StoneAmount.value + this.form.OtherAmount.value;

                        if (SplitLabor)
                            this.form.GrossAmount.value = this.form.NetAmount.value + this.form.UnitLabour.value + this.form.FancyCharges.value + this.form.OtherCharges.value;
                        else
                            this.form.GrossAmount.value = this.form.NetAmount.value + this.form.UnitLabour.value - this.form.Discount.value;


                    }
                    else {
                        this.form.NetAmount.value = this.form.Weight.value * this.form.UnitRate.value;
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else if (parseInt(this.form.CalcOnId.value) == 3 && this.form.UnitRate.value > 0) {
                    this.form.NetAmount.value = this.form.Pieces.value * this.form.UnitRate.value;
                    this.form.GrossAmount.value = this.form.NetAmount.value;

                }
                if (this.form.ItemTypeId.value == 104) {
                    this.form.PureWeight.value = this.form.Purity.value * this.form.Weight.value;
                }
            }
            else {
                if (parseInt(this.form.CalcOnId.value) == 3 && this.form.UnitRate.value > 0) {
                    this.form.Weight.value = this.form.Weight.value * this.form.Pieces.value;
                    this.form.NetWeight.value = this.form.NetWeight.value * this.form.Pieces.value;
                    //this.form.NetAmount.value = this.form.Pieces.value * (this.form.UnitRate.value + this.form.UnitLabour.value);
                    this.form.NetAmount.value = this.form.UnitRate.value;

                    if (SplitLabor)
                        this.form.GrossAmount.value = (this.form.Pieces.value * this.form.NetAmount.value) + this.form.UnitLabour.value + this.form.FancyCharges.value + this.form.OtherCharges.value;
                    else
                        this.form.GrossAmount.value = (this.form.Pieces.value * this.form.NetAmount.value) + this.form.UnitLabour.value;

                    //this.form.GrossAmount.value = this.form.NetAmount.value;
                }
                Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
            }

            this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
            this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;

        }

        protected GetRate() {

            if (this.form.ItemTypeId.value == 105) {
                var rateatb: TabAurous.RateHelper.RateAttributes = {
                    ProductTypeId: parseInt(this.form.ProductTypeId.value),
                    CategoryId: parseInt(this.form.CategoryId.value),
                    SubCategoryId: parseInt(this.form.SubCategoryId.value),
                    ShapeId: parseInt(this.form.ShapeId.value),
                    SieveId: parseInt(this.form.SieveId.value),
                    GroupSieveId: parseInt(this.form.GroupSieveId.value),
                    StoneSizeId: parseInt(this.form.StoneSizeId.value),
                    StoneColorId: parseInt(this.form.StoneColorId.value),
                    QualityId: parseInt(this.form.QualityId.value),
                    RateListId: this.RateListId,
                    ProductId: parseInt(this.form.ProductId.value),
                    CostMethodId: parseInt(this.form.CostMethodId.value),
                    Weight: this.form.Weight.value
                }
                this.form.UnitRate.value = TabAurous.RateHelper.GetStonePurchaseRatenoAtb(rateatb);
            }

            if (this.StoneMarkup > 0)
                this.form.UnitRate.value = (this.form.UnitRate.value * (this.StoneMarkup / 100)) + this.form.UnitRate.value / this.ExchangeRate;
            if (this.StoneDiscount > 0)
                this.form.UnitRate.value = this.form.UnitRate.value - (this.form.UnitRate.value * (this.StoneMarkup / 100)) / this.ExchangeRate;

            if (this.form.UnitRate.value > 0)
                this.CalculateRate();
        }

        protected UpdateLabor() {
            let labor = []
            for (let x of this.form.LaborDetails.getItems()) {
                if (x.ItemTypeId == 101) {
                    x.Weight = this.form.Weight.value;
                    x.Pieces = this.form.Pieces.value;
                    x.LabourAmount = x.CalcOnId == 61 ? this.form.Pieces.value * x.LabourRate : x.CalcOnId == 62 ? this.form.NetWeight.value * x.LabourRate : this.form.Weight.value * x.LabourRate;
                }
                labor.push(x);
            }

            this.form.LaborDetails.setItems(labor);
        }

        parentEditor: StockInItemGridEditor<TEntity>;
    }
}